
// Selection criteria code mappings
const selectionCriteriaMap: Record<string, string> = {
  'ef-stand': 'Economic and Financial Standing',
  'tp-abil': 'Technical and Professional Ability',
  'sui-act': 'Suitability to Pursue the Activity',
  'slc-env': 'Environmental Management Standards',
  'slc-qua': 'Quality Assurance Standards',
  'slc-sup': 'Supply Chain Management',
  'slc-req': 'Requirements in Regulated Professions',
  'slc-reg': 'Professional Register Enrollment',
  'slc-oth': 'Other Selection Criteria',
  'slc-eco': 'Economic Criteria'
};

// Exclusion grounds code mappings
const exclusionGroundsMap: Record<string, string> = {
  'envir-law': 'Environmental Law Violations',
  'socsec-law': 'Social Security Law Violations',
  'labour-law': 'Labor Law Violations',
  'bankruptcy': 'Bankruptcy',
  'insolvency': 'Insolvency',
  'cred-arran': 'Arrangement with Creditors',
  'bankr-nat': 'Bankruptcy Similar Situation under National Law',
  'liq-admin': 'Assets Being Administered by Liquidator',
  'susp-act': 'Business Activities Suspended',
  'prof-misconduct': 'Grave Professional Misconduct',
  'distorsion': 'Distortion of Competition',
  'partic-confl': 'Conflict of Interest (Participation)',
  'prep-confl': 'Conflict of Interest (Preparation)',
  'sanction': 'Prior Sanctions or Termination',
  'misrepresent': 'Misrepresentation of Information',
  'nati-ground': 'Exclusion on National Grounds',
  'terr-offence': 'Terrorist Offenses',
  'socsec-pay': 'Social Security Contribution Non-payment',
  'tax-pay': 'Tax Non-payment',
  'crime-org': 'Participation in Criminal Organization',
  'finan-laund': 'Money Laundering or Terrorist Financing',
  'fraud': 'Fraud',
  'human-traffic': 'Human Trafficking',
  'corruption': 'Corruption'
};

/**
 * Checks if a field key relates to selection criteria
 */
export const isSelectionCriteriaField = (key: string): boolean => {
  return (
    key.includes('selection-criterion') || 
    key === 'BT-747-Lot' ||
    key === 'BT-809-Lot' ||
    key.includes('slc-') ||
    key === 'selection-criterion-lot' ||
    ['ef-stand', 'tp-abil', 'sui-act'].some(code => key.includes(code))
  );
};

/**
 * Checks if a value is a selection criteria code
 */
export const isSelectionCriteriaCode = (value: string): boolean => {
  return Object.keys(selectionCriteriaMap).includes(value) || 
         Object.keys(exclusionGroundsMap).includes(value);
};

/**
 * Gets the human-readable description for a selection criteria code
 */
export const getSelectionCriteriaDescription = (code: string): string => {
  if (selectionCriteriaMap[code]) {
    return selectionCriteriaMap[code];
  }
  
  if (exclusionGroundsMap[code]) {
    return exclusionGroundsMap[code];
  }
  
  return code;
};

/**
 * Check if a field and value combination represents a coded field
 * This helps in identifying fields that should be displayed with their code descriptions
 */
export const isCodedFieldValue = (key: string, value: string): boolean => {
  // Selection criteria and exclusion grounds
  if (isSelectionCriteriaCode(value)) {
    return true;
  }
  
  // Strategic procurement types
  if (key === 'strategic-procurement-lot' || key === 'BT-06-Lot') {
    return ['none', 'social', 'env', 'innov'].includes(value);
  }
  
  // Environmental impact approach
  if (key === 'environmental-impact-lot' || key === 'BT-774-Lot') {
    return ['co2', 'costs', 'emissions', 'energy', 'other', 'none'].includes(value);
  }
  
  // Document access restriction
  if (key === 'document-restricted-lot' || key === 'BT-14-Lot' || key === 'BT-14-Part') {
    return ['restricted', 'partially', 'not-restricted'].includes(value);
  }
  
  return false;
};
